import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantRestrictivePractice } from '../mutations/updateParticipantRestrictivePractice.mutation';
import type {
  UpdateParticipantRestrictivePracticeMutation,
  UpdateParticipantRestrictivePracticeMutationVariables,
} from '../types';

export const useUpdateParticipantRestrictivePracticeMutation = (
  options?: MutationOptions<
    UpdateParticipantRestrictivePracticeMutation,
    UpdateParticipantRestrictivePracticeMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantRestrictivePractice), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
